var React = require('react');

function UploadIcon (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Shape"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"Icons","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round","key":2},React.createElement("g",{"id":"Icons-/-Share","transform":"translate(-3.000000, 0.000000)","stroke":"#5E5E5E","strokeWidth":"1.5"},React.createElement("path",{"d":"M17.25,8.25 L18.75,8.25 C19.5784271,8.25 20.25,8.92157288 20.25,9.75 L20.25,21.75 C20.25,22.5784271 19.5784271,23.25 18.75,23.25 L5.25,23.25 C4.42157288,23.25 3.75,22.5784271 3.75,21.75 L3.75,9.75 C3.75,8.92157288 4.42157288,8.25 5.25,8.25 L6.75,8.25 M12,0.75 L12,11.25 M8.25,4.5 L12,0.75 L15.75,4.5","id":"Shape"})))]);
}

UploadIcon.defaultProps = {"width":"18px","height":"24px","viewBox":"0 0 18 24","version":"1.1"};

module.exports = UploadIcon;

UploadIcon.default = UploadIcon;
